import { searchCity, getCityByCountryCode, getCountries, getCityDestinationByCountryCode, searchCityAndPort } from '@/api/city.api'
import {getProvincesByCountryId, getDistrictsByCityId, getSubDistrictsByDistrictId, getCitiesByProvinceId} from '@/api/country.api.js'

export const FETCH_CITIES = 'FETCH_CITIES'
export const FETCH_CITIES_LOADING = 'FETCH_CITIES_LOADING'
export const FETCH_CITIES_DONE = 'FETCH_CITIES_DONE'
export const FETCH_CITIES_ERROR = 'FETCH_CITIES_ERROR'

export const FETCH_COUNTRIES = 'FETCH_COUNTRIES'
export const FETCH_COUNTRIES_LOADING = 'FETCH_COUNTRIES_LOADING'
export const FETCH_COUNTRIES_DONE = 'FETCH_COUNTRIES_DONE'
export const FETCH_COUNTRIES_ERROR = 'FETCH_COUNTRIES_ERROR'

export const FETCH_CITIES_BY_NAME = 'FETCH_CITIES_BY_NAME'
export const FETCH_CITIES_LOADING_BY_NAME = 'FETCH_CITY_LOADING_BY_NAME'
export const FETCH_CITIES_DONE_BY_NAME = 'FETCH_CITIES_DONE_BY_NAME'
export const FETCH_CITIES_ERROR_BY_NAME = 'FETCH_CITIES_ERROR_BY_NAME'

export const FETCH_CITIES_DESTINATION = 'FETCH_CITIES_DESTINATION'
export const FETCH_CITIES_DESTINATION_LOADING = 'FETCH_CITIES_DESTINATION_LOADING'
export const FETCH_CITIES_DESTINATION_DONE = 'FETCH_CITIES_DESTINATION_DONE'
export const FETCH_CITIES_DESTINATION_ERROR = 'FETCH_CITIES_DESTINATION_ERROR'

export const FETCH_CITY_PORT = 'FETCH_CITY_PORT'
export const FETCH_CITY_PORT_LOADING = 'FETCH_CITY_PORT_LOADING'
export const FETCH_CITY_PORT_DONE = 'FETCH_CITY_PORT_DONE'
export const FETCH_CITY_PORT_ERROR = 'FETCH_CITY_PORT_ERROR'

export const FETCH_PROVINCE_BY_COUNTRY = 'FETCH_PROVINCE_BY_COUNTRY'
export const FETCH_PROVINCE_BY_COUNTRY_LOADING = 'FETCH_PROVINCE_BY_COUNTRY_LOADING'
export const FETCH_PROVINCE_BY_COUNTRY_DONE = 'FETCH_PROVINCE_BY_COUNTRY_DONE'
export const FETCH_PROVINCE_BY_COUNTRY_ERROR = 'FETCH_PROVINCE_BY_COUNTRY_ERROR'

export const FETCH_CITY_BY_PROVINCE = 'FETCH_CITY_BY_PROVINCE'
export const FETCH_CITY_BY_PROVINCE_LOADING = 'FETCH_CITY_BY_PROVINCE_LOADING'
export const FETCH_CITY_BY_PROVINCE_DONE = 'FETCH_CITY_BY_PROVINCE_DONE'
export const FETCH_CITY_BY_PROVINCE_ERROR = 'FETCH_CITY_BY_PROVINCE_ERROR'

export const FETCH_DISTRICT_BY_CITY = 'FETCH_DISTRICT_BY_CITY'
export const FETCH_DISTRICT_BY_CITY_LOADING = 'FETCH_DISTRICT_BY_CITY_LOADING'
export const FETCH_DISTRICT_BY_CITY_DONE = 'FETCH_DISTRICT_BY_CITY_DONE'
export const FETCH_DISTRICT_BY_CITY_ERROR = 'FETCH_DISTRICT_BY_CITY_ERROR'

export const FETCH_SUBDISTRICT_BY_DISTRICT = 'FETCH_SUBDISTRICT_BY_DISTRICT'
export const FETCH_SUBDISTRICT_BY_DISTRICT_LOADING = 'FETCH_SUBDISTRICT_BY_DISTRICT_LOADING'
export const FETCH_SUBDISTRICT_BY_DISTRICT_DONE = 'FETCH_SUBDISTRICT_BY_DISTRICT_DONE'
export const FETCH_SUBDISTRICT_BY_DISTRICT_ERROR = 'FETCH_SUBDISTRICT_BY_DISTRICT_ERROR'

export default {
  [FETCH_CITIES] (context, payload) {
    context.commit(FETCH_CITIES_LOADING)
    return getCityByCountryCode(payload)
      .then((response) => {
        context.commit(FETCH_CITIES_DONE, response.data)
      })
      .catch((error) => {
        context.commit(FETCH_CITIES_ERROR, error)
      })
  },

  [FETCH_COUNTRIES] (context) {
    context.commit(FETCH_COUNTRIES_LOADING)
    return getCountries()
      .then((response) => {
        context.commit(FETCH_COUNTRIES_DONE, response.data)
      })
      .catch((error) => {
        context.commit(FETCH_COUNTRIES_ERROR, error)
      })
  },

  [FETCH_CITIES_BY_NAME] (context, payload) {
    context.commit(FETCH_CITIES_LOADING_BY_NAME)
    return searchCity(payload)
      .then((response) => {
        context.commit(FETCH_CITIES_DONE_BY_NAME, response.data)
      })
      .catch((error) => {
      // eslint-disable-next-line
      context.commit(FETCH_CITIES_ERROR_BY_NAME, error)
      })
  },

  [FETCH_CITIES_DESTINATION] (context, payload) {
    context.commit(FETCH_CITIES_DESTINATION_LOADING)
    return getCityDestinationByCountryCode(payload)
      .then((response) => {
        context.commit(FETCH_CITIES_DESTINATION_DONE, response.data)
      })
      .catch((error) => {
        context.commit(FETCH_CITIES_DESTINATION_ERROR, error)
      })
  },

  [FETCH_CITY_PORT] (context, payload) {
    const routeType = payload.routeType || 'origin' // origin / destination
    context.commit(FETCH_CITY_PORT_LOADING, routeType)
    return searchCityAndPort(payload)
      .then((response) => {
        context.commit(FETCH_CITY_PORT_DONE, {data: response.data, routeType})
      })
      .catch((error) => {
      // eslint-disable-next-line
      context.commit(FETCH_CITY_PORT_ERROR, {error, routeType})
      })
  },

  [FETCH_PROVINCE_BY_COUNTRY] (context, payload) {
    context.commit(FETCH_PROVINCE_BY_COUNTRY_LOADING, payload)
    return getProvincesByCountryId(payload)
      .then((response) => {
        context.commit(FETCH_PROVINCE_BY_COUNTRY_DONE, response.data)
      })
      .catch((error) => {
      // eslint-disable-next-line
      context.commit(FETCH_PROVINCE_BY_COUNTRY_ERROR, error)
      })
  },

  [FETCH_CITY_BY_PROVINCE] (context, payload) {
    context.commit(FETCH_CITY_BY_PROVINCE_LOADING, payload)
    return getCitiesByProvinceId(payload)
      .then((response) => {
        context.commit(FETCH_CITY_BY_PROVINCE_DONE, response.data)
      })
      .catch((error) => {
      // eslint-disable-next-line
      context.commit(FETCH_CITY_BY_PROVINCE_ERROR, error)
      })
  },

  [FETCH_DISTRICT_BY_CITY] (context, payload) {
    context.commit(FETCH_DISTRICT_BY_CITY_LOADING, payload)
    return getDistrictsByCityId(payload)
      .then((response) => {
        context.commit(FETCH_DISTRICT_BY_CITY_DONE, response.data)
      })
      .catch((error) => {
      // eslint-disable-next-line
      context.commit(FETCH_DISTRICT_BY_CITY_ERROR, error)
      })
  },

  [FETCH_SUBDISTRICT_BY_DISTRICT] (context, payload) {
    context.commit(FETCH_SUBDISTRICT_BY_DISTRICT_LOADING, payload)
    return getSubDistrictsByDistrictId(payload)
      .then((response) => {
        context.commit(FETCH_SUBDISTRICT_BY_DISTRICT_DONE, response.data)
      })
      .catch((error) => {
      // eslint-disable-next-line
      context.commit(FETCH_SUBDISTRICT_BY_DISTRICT_ERROR, error)
      })
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/city/actions.js